import { Button, Card, CardBody, ModalContent, useDisclosure } from '@nextui-org/react'
import { SubmitTankArrayType } from '../../types/apiResponse/tankTypes'
import { BaseModal } from '../common/Modal'
// Replaced dropdown with unified selector
import useCustomizeLiveStore from '@/store/live/useCustomizeLiveStore'
import { FC, useState } from 'react'
import cross from '../../assets/icons/cross.png'
import { SelectTank } from '../../pages/SelectTank'
import { camListArrayType, camListType } from '../../types/props/live'
import {
  cameraListUpdater,
  cameraPositionSet,
  removeCamera,
} from '../../utils/live/cameraPositionFuncs'
import CameraPositionSelector from './CameraPositionSelector'

type SelectPreviewTankProps = {
  loc: number
  item: camListType
  i: number
  index: number
  cameraList: camListArrayType
  setCameraList: (camList: camListArrayType) => void
  groupIds: string[]
}

export const SelectPreviewTank: FC<SelectPreviewTankProps> = ({
  loc,
  item,
  i,
  index,
  cameraList,
  setCameraList,
  groupIds,
}) => {
  const {
    isOpen: isOpenTanks,
    onOpen: onOpenTanks,
    onOpenChange: onOpenChangeTanks,
  } = useDisclosure()
  const [isEnter, setIsEnter] = useState<boolean>(false)

  const { allCamerasMap, cameraGrid } = useCustomizeLiveStore()

  const selectCamera = () => {
    onOpenTanks()
  }

  return (
    <Card
      key={loc}
      onMouseEnter={() => setIsEnter(true)}
      onMouseLeave={() => setIsEnter(false)}
      shadow="sm"
      className="m-0 border shadow-none border-tdpldarkgrey border-opacity-60"
      style={{ pointerEvents: 'auto' }}
    >
      <Button
        hidden={isEnter && item.tankName ? false : true}
        size="sm"
        className="absolute right-2 top-2 z-10 w-[1rem] h-[1rem] min-w-0 min-h-0 bg-opacity-0"
        isIconOnly
        onClick={() => removeCamera(loc, cameraList, setCameraList)}
      >
        <img className="object-scale-down w-[1rem] h-[1rem]" src={cross} alt="" />
      </Button>
      <CardBody className="py-2 overflow-visible" style={{ position: 'relative', zIndex: 1 }}>
        <Button
          key={loc}
          id={String(loc)}
          size="sm"
          className={`font-bold border border-tdpldarkgrey border-opacity-60 bg-tdplsky ${item.tankName ? '' : 'text-opacity-40'}`}
          style={{
            width: 'fit-content',
            alignSelf: 'center',
            fontSize: '1rem',
            marginBottom: '0.5rem',
            marginLeft: 0,
            position: 'relative',
            zIndex: 10,
            pointerEvents: 'auto',
          }}
          onPress={selectCamera}
        >
          {item.tankName ? item.tankName : 'Select Tank'}
        </Button>
        <BaseModal
          isOpen={isOpenTanks}
          onOpenChange={onOpenChangeTanks}
          size={'3xl'}
          backdrop={'opaque'}
        >
          <ModalContent style={{ zIndex: 10000 }}>
            {(onCloseTanks) => (
              <SelectTank
                key={loc}
                submitTankArray={(tankSelectedList: SubmitTankArrayType) => {
                  cameraListUpdater(loc, tankSelectedList, cameraList, setCameraList)
                  onCloseTanks()
                }}
                groupIds={groupIds}
                onClose={onCloseTanks}
                limit={1}
                instantSelect
                availableMap={allCamerasMap ?? undefined}
              />
            )}
          </ModalContent>
        </BaseModal>
        {/* camera position selection */}
        {item.tankName && (
          <CameraPositionSelector
            selected={(item.cameraPosition as any) ?? null}
            onSelect={(pos) =>
              cameraPositionSet(i * Number(cameraGrid[0]) + index, pos, cameraList, setCameraList)
            }
            availablePositions={(() => {
              const disabled = (allCamerasMap && item.tankId && allCamerasMap[item.tankId]) || []
              const all: Array<'left' | 'top' | 'right'> = ['left', 'top', 'right']
              return all.filter((p) => !disabled.includes(p))
            })()}
          />
        )}
      </CardBody>
    </Card>
  )
}
